import React from 'react';

const Download = (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='10' cy='10' r='10' fill='#6347FF' />
        <path d='M15 10L14.1187 9.11875L10.625 12.6062V5H9.375V12.6062L5.8875 9.1125L5 10L10 15L15 10Z' fill='white' />
    </svg>
);

export default Download;
